import * as React from 'react';

type Params = {
  isOpen: boolean;
  onClose: () => void;
  wrapRef: React.RefObject<HTMLElement | null>;
  enabled?: boolean;
  gate?: boolean;
};

export function useCloseOnOutside({ isOpen, onClose, wrapRef, enabled = true, gate = true }: Params) {
  React.useEffect(() => {
    if (!enabled) return;
    if (!gate) return;
    if (!isOpen) return;

    const onDocMouseDown = (e: any) => {
      try {
        const el = wrapRef.current;
        const target = e && e.target;
        if (!el || !target) return;
        if (!el.contains(target)) onClose();
      } catch {
        onClose();
      }
    };

    const onDocKeyDown = (e: any) => {
      const key = e && (e.key || e.code);
      if (key === 'Escape' || key === 'Esc') onClose();
    };

    document.addEventListener('mousedown', onDocMouseDown, true);
    document.addEventListener('touchstart', onDocMouseDown, true);
    document.addEventListener('keydown', onDocKeyDown, true);

    return () => {
      document.removeEventListener('mousedown', onDocMouseDown, true);
      document.removeEventListener('touchstart', onDocMouseDown, true);
      document.removeEventListener('keydown', onDocKeyDown, true);
    };
  }, [enabled, gate, isOpen, onClose, wrapRef]);
}
